import { message } from "antd";
import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import actions from "../actions/actions";
import getAddressMeters from "./getAddressMeters";
import getAddresses from "./getAddresses";
import moment from "moment";
import bindTagToMeter from "../../requests/bindTagToMeter";
import deleteTagFromMeter from "../../requests/deleteTagFromMeter";

const editMeter = (meter, newValues) => async (dispatch) => {
	const url = "/Meter/update_meter";
	try {
		dispatch({ type: actions.ITEM_LOADING });
		await client.post(
			url,
			{
				MeterId: meter.id,
				CommissionningDate: moment(newValues.CommissionningDate.format('YYYY-MM-DD[T00:00:00]')).utc().format(),
				DecommissionningDate: moment(newValues.DecommissionningDate.format('YYYY-MM-DD[T00:00:00]')).utc().format(),
				Description: newValues.Description,
				Coef: newValues.Coef,
        MeterStatusId: newValues.MeterStatusId,
        MeterTariffId: newValues.MeterTariffId,
			},
			{
				headers: authHeader(),
			}
		);
		if (!newValues.Tag && meter.tagList?.length === 1) {
			await deleteTagFromMeter(meter.id, meter.tagList[0].id);
		}
		if (newValues.Tag && meter.tagList?.length === 0) {
			await bindTagToMeter(meter.id, newValues.Tag);
		}
		message.success(`Счётчик №${meter.meterCode} изменён`);
	} catch (e) {
		message.error("При удалении счётчика произошла ошибка");
		console.error(e);
	}
};

export default editMeter;
